<template>
  <!-- Some notes:
    - possible_values is an array of objects with the following format {"label":"val","value":"val"}.
    - selected_values is an array of objects with the same format and managed by Vue.js (v-model is a two-way binding)
    - track-by is used to identify the elements of the multiselect list and thus has to be unique
    - label is used to display an element of the list
  -->
  <div>
    <h2>FAQ - Häufig gestellte Fragen...</h2>
      <p>Sollten Sie eine Frage haben, die hier nicht aufgeführt ist, hilft Ihnen unser
        <a :href="supportUrl">Support</a> gerne weiter.
      </p>
    <br/>
    <br/>
    <!-- Filter removed - can be reactivated when we should have many entries in FAQ -->
    <div v-if="loading">
      <div>
        <i class="fa fa-spin fa-spinner"></i> FAQs werden geladen ...
      </div>
    </div>
    <div v-else>
        <div class="card-container-faq" v-for="faq in faqs" :key="faq.id">
          <div role="tablist">
            <b-card no-body :ref="'faqcontainer' + faq.id">
              <b-card-header header-tag="header" class="card-header-faq" role="tab">
                <b-btn block v-b-toggle="'faq-id-' + faq.id" variant="light" class="btn-faq">
                  {{faq.subject}}
                  <i class="fa fa-arrow-down"></i>
                </b-btn>
              </b-card-header>
              <b-collapse :id="'faq-id-' + faq.id" :visible="getUrlParam('fid') == faq.id" accordion="my-accordion" role="tabpanel">
                <b-card-body>
                  <vue-markdown>{{faq.description}}</vue-markdown>
                </b-card-body>
              </b-collapse>
            </b-card>
          </div>
        </div>
    </div>
  </div>
</template>

<script>
import VueMarkdown from 'vue-markdown'
import Multiselect from "vue-multiselect";
// TODO This did not work because webpack attempted to parse the file unsuccesfully
// import 'vue-multiselect/dist/vue-multiselect.min.css'
/**
 * The component's properties are initialized and passed as a configuration object at instantiation time
 * For more detail have a look at app.js -> registerDynamic()
 */
export default {
  props: ["apiUrl", "product", "project", "tracker", "status"],
  components: {
    VueMarkdown, Multiselect
  },
  data() {
    return {
      supportUrl: document.body.getAttribute('data-api-support-url'),
      updateCount: 0,
      selectedTags: {},
      loading:false
    };
  },
  asyncComputed: {
    tags: {
      get() {
        return this.$http
          .post(this.apiUrl + "/faqtags", { params: this.tagParams })
          .then(response => {
            return response.body.data.map(tag => {
              return Object.assign({ selected_values: [] }, tag);
            });
          });
      },
      default: []
    },
    faqs: {
      get() {
        this.loading = true;
        return this.$http
          .post(this.apiUrl + "/faqs", {
            params: { selectedTags: this.faqParams , baseTag: this.product, project: this.project, status: this.status}
          })
          .then(response => {
            this.loading = false;
            return response.body.data.map((faq) => {
              if (faq.id == this.getUrlParam('fid')){
                this.scrollToFAQ('faqcontainer' + faq.id);
              }
              return faq;
            });
          })
          .catch(error => error);
      },
      default: []
    }
  },
  computed: {
    faqParams() {
      this.updateCount
      let parameters = this.tags.filter(tag => tag.id in this.selectedTags)
      .map(tag => {
        return { id: tag.id, selected_values: this.selectedTags[tag.id] };
      })
      // Filter the objects associated with non-empty selections
      .filter(obj => obj.selected_values.length > 0); 
      return parameters
    },
    tagParams() {
      return { product: this.product, tracker: this.tracker };
    },
  },
  methods: {
     getUrlParam(name) {
       const url = window.location.href;
        name = name.replace(/[\[\]]/g, '\\$&');
        const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    },
    scrollToFAQ(refName) {   
      this.$nextTick(() => {
        setTimeout(() => {
          let element = this.$refs[refName][0];
          element.scrollIntoView();
        }, 0);
      });
    }
  }
};
</script>
    
<style></style>